import React from 'react'
import { Redirect } from 'react-router-dom'
import Loader from '../../components/Loader'

class Logout extends React.Component {
  componentDidMount() {
    if (this.props.authed) {
      this.props.logout()
    }
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    if (!this.props.authed) {
      return <Redirect to="/login" />
    }
    return <Loader />
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/modules/Logout/Logout.jsx